"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _SquareBorderButton = _interopRequireDefault(require("../Button/SquareBorderButton"));

var _Confirmation = _interopRequireDefault(require("./Confirmation.style"));

var _class, _temp;

var defConfirmBtnProps = {
  text: 'OK',
  size: 'medium',
  type: 'filled',
  status: 'danger',
  autoFocus: true
};
var defCancelBtnProps = {
  text: 'Cancel',
  size: 'medium'
};

var Confirmation = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Confirmation, _PureComponent);

  function Confirmation() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Confirmation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Confirmation)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderOverlay", function (close) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          onConfirm = _this$props.onConfirm,
          title = _this$props.title,
          message = _this$props.message,
          confirmBtnProps = _this$props.confirmBtnProps,
          cancelBtnProps = _this$props.cancelBtnProps,
          hideCancelBtn = _this$props.hideCancelBtn;
      return _react.default.createElement("section", null, title && _react.default.createElement("header", {
        className: _Confirmation.default.header(theme)
      }, title), _react.default.createElement("main", {
        className: _Confirmation.default.main(theme, title)
      }, message), _react.default.createElement("footer", {
        className: _Confirmation.default.footer(theme)
      }, _react.default.createElement(_SquareBorderButton.default, (0, _extends2.default)({
        onClick: function onClick(e) {
          onConfirm(e);
          close(e);
        }
      }, defConfirmBtnProps, confirmBtnProps)), !hideCancelBtn && _react.default.createElement(_SquareBorderButton.default, (0, _extends2.default)({
        onClick: close
      }, defCancelBtnProps, cancelBtnProps))));
    });
    return _this;
  }

  (0, _createClass2.default)(Confirmation, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dropdownPlacement = _this$props2.dropdownPlacement,
          overlayClassName = _this$props2.overlayClassName,
          popupWrapperZIndex = _this$props2.popupWrapperZIndex,
          popupCustomStyle = _this$props2.popupCustomStyle,
          parentNode = _this$props2.parentNode;
      return _react.default.createElement(_Dropdown.default, {
        overlay: this.renderOverlay,
        placement: dropdownPlacement,
        popupWrapperClassName: overlayClassName,
        popupWrapperZIndex: popupWrapperZIndex,
        popupCustomStyle: popupCustomStyle,
        parentNode: parentNode
      }, this.props.children);
    }
  }]);
  return Confirmation;
}(_react.PureComponent), _temp)) || _class;

Confirmation.defaultProps = {
  confirmBtnProps: null,
  cancelBtnProps: null,
  hideCancelBtn: false,
  dropdownPlacement: undefined,
  title: null,
  overlayClassName: '',
  popupCustomStyle: {},
  parentNode: document.body
};
Confirmation.propTypes = {
  onConfirm: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  confirmBtnProps: _propTypes.default.shape({}),
  cancelBtnProps: _propTypes.default.shape({}),
  hideCancelBtn: _propTypes.default.bool,
  dropdownPlacement: _propTypes.default.oneOf(['bottomLeft', 'bottomRight']),
  overlayClassName: _propTypes.default.string,
  popupCustomStyle: _propTypes.default.object,
  parentNode: _propTypes.default.instanceOf(Element)
};
var _default = Confirmation;
exports.default = _default;